import {Alert, Button, Checkbox, Input, Typography} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import "../../style/datePicker.css"
import {getServiceAgentBranchFeeInfo} from "../../services/agent_branch_fee/agent_branch_fee";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {updateServicePriceAndDay} from "../../services/service/service";
import {ServiceContext} from "./service_context";
import {Toaster} from "../../helper/Toaster";

export function ServiceDetailForm() {

  const {
    service,
    setService,
    from,
    setLastDataRefresh,
    branchInfo,
    setBranchInfo
  } = useContext(ServiceContext);

  const disable = service.status === "finish"

  const [currPrice, setCurrPrice] = useState(service.price);
  const [currDay, setCurrDay] = useState(service.day)

  useEffect(() => {
    if (branchInfo?.consensual === false) {
      setCurrPrice(branchInfo.price)
      setService(service => ({
        ...service,
        price: branchInfo.price,
      }))
    }

    if (branchInfo?.period === false) {
      setCurrPrice(branchInfo.day)
      setService(service => ({
        ...service,
        day: branchInfo.day,
      }))
    }

  }, [branchInfo]);

  useEffect(() => {
    async function getData() {
      const result = await getServiceAgentBranchFeeInfo(service.agent_id, service.branch_id);
      if (result.status === 200) {
        const {service_agent_branch_fee_info} = result.data;
        setBranchInfo(service_agent_branch_fee_info)
      }
    }

    if (service.agent_id && service.branch_id) {
      getData()
    }
  }, [service.branch_id]);

  const save = async () => {
    const data = {
      id: service.id,
      price: parseInt(currPrice),
      day: parseInt(currDay)
    };

    let result;

    result = await updateServicePriceAndDay(data)

    if (result.status === 202) {
      const new_day = currDay
      const new_price = currPrice
      const new_service = service
      new_service.price = new_price
      new_service.day = new_day
      setService(new_service)
    }
  };

  if (branchInfo?.agent_branch_id > 0) {
    return (
      <>
        {from === "agent" &&
          <Alert className="mb-8 w-full px-0" variant="outlined">
            <Typography variant="h5" className="mb-4">
              مشاور گرامی، لطفا به نکات زیر توجه فرمائید:
            </Typography>
            <Typography variant="body" color="blue-gray">
              <li>
                لطفا در تعیین قیمت خدمات و زمان انجام خدمات دقت لازم را بعمل آورید، زیرا هرگونه تغییر در قیمت و زمان
                ارائه خدمات امکان پذیر نیست و مشمول جریمه شما و کسر از مبلغ خدمات خواهد بود.
              </li>
              <li>
                لطفا در زمان تعیین قیمت به مواردی همچون؛ هزینه دستمزد و حق الزحمه خود، سهم پلتفرم مباشر، هزینه های دولتی
                و جانبی و مباحث ارزش افزوده و کسورات قانونی را در نظر بگیرید.
              </li>
            </Typography>
          </Alert>
        }
        {service.topic?.length > 0 &&
          <div className="flex flex-row mb-4 pb-2 border-b-2">
            <Typography className="flex flex-col ml-2">
              {Dict('service_topic_2') + ": "}
            </Typography>
            <Typography className="flex flex-col" color="blue-gray">
              {service.topic}
            </Typography>
          </div>
        }

        {service.challenge?.length > 0 &&
          <div className="flex flex-row mb-4 pb-2 border-b-2">
            <Typography className="flex flex-col ml-2">
              {Dict('challenge') + ": "}
            </Typography>
            <Typography className="flex flex-col" color="blue-gray">
              {service.challenge}
            </Typography>
          </div>
        }

        {!branchInfo.consensual &&
          <div className="grid grid-cols-1 md:grid-cols-2 xxl:grid-cols-3">
            <div className="flex flex-row border-l-2">
              <Typography className="flex flex-col ml-2">
                {Dict('service_price') + ": "}
              </Typography>
              <Typography className="flex flex-col" color="blue-gray">
                {persianNumberFormat(branchInfo.price, true) + " ریال"}
              </Typography>
            </div>
          </div>
        }

        {branchInfo.consensual &&
          <div className="grid grid-cols-1 md:grid-cols-2 xxl:grid-cols-3 pb-2 border-b-2">
            <div className="mb-4 md:ml-3">
              <div className="flex flex-row border-l-2">
                <Typography className="flex flex-col ml-2">
                  {Dict('min_service_price') + ": "}
                </Typography>
                <Typography className="flex flex-col" color="blue-gray">
                  {persianNumberFormat(branchInfo.min_price, true) + " ریال"}
                </Typography>
              </div>
            </div>

            <div className="mb-4 md:mr-3">
              <div className="flex flex-row">
                <Typography className="flex flex-col ml-2">
                  {Dict('max_service_price') + ": "}
                </Typography>
                <Typography className="flex flex-col" color="blue-gray">
                  {persianNumberFormat(branchInfo.max_price, true) + " ریال"}
                </Typography>
              </div>
            </div>
          </div>
        }

        {branchInfo.side_cost &&
          <>
            <Checkbox
              checked={branchInfo.side_cost}
              label={
                <Typography color="blue-gray" className="flex font-medium">
                  هزینه‌های جانبی
                </Typography>
              }
            />
            <div className="mb-4 flex flex-col pb-2 border-b-2">
              <div className="flex flex-row">
                <Typography className="flex flex-col ml-2 mb-4">
                  {Dict('side_cost_description') + ": "}
                </Typography>
                <Typography className="flex flex-col" color="blue-gray">
                  {branchInfo.side_cost_description}
                </Typography>
              </div>
              <div className="flex flex-row">
              </div>
            </div>
          </>
        }
        <div className="grid grid-cols-1 gap-6 mt-2 pb-2 border-b-2 md:grid-cols-2 xxl:grid-cols-3">
          {!branchInfo.period &&
            <div className="mb-4">
              <div className="flex flex-row">
                <Typography className="flex flex-col ml-2 mb-4">
                  {Dict('service_day') + ": "}
                </Typography>
                <Typography className="flex flex-col" color="blue-gray">
                  {persianNumberFormat(branchInfo.day) + " روز"}
                </Typography>
              </div>
            </div>
          }
          {branchInfo.period &&
            <>
              <div className="mb-4 border-l-2">
                <div className="flex flex-row">
                  <Typography className="flex flex-col ml-2">
                    {Dict('min_service_day') + ": "}
                  </Typography>
                  <Typography className="flex flex-col" color="blue-gray">
                    {persianNumberFormat(branchInfo.min_day) + " روز"}
                  </Typography>
                </div>
              </div>

              <div className="mb-4">
                <div className="flex flex-row">
                  <Typography className="flex flex-col ml-2">
                    {Dict('max_service_day') + ": "}
                  </Typography>
                  <Typography className="flex flex-col" color="blue-gray">
                    {persianNumberFormat(branchInfo.max_day) + " روز"}
                  </Typography>
                </div>
              </div>
            </>
          }
        </div>

        <div className="grid grid-cols-1 gap-6 mt-4 pb-2 border-b-2 md:grid-cols-2 xxl:grid-cols-3">
          {branchInfo.consensual && !disable &&
            <>
              <div className="mb-4 border-l-2">
                {!service.price && from === "agent" &&
                  <div className="flex flex-row w-3/4">
                    <Input variant="standard"
                           value={currPrice}
                           type="number"
                           label={Dict('service_price')}
                           placeholder={Dict('service_price')}
                           onChange={(e) => {
                             setCurrPrice(e.target.value)
                           }}
                    />
                  </div>
                }
                {currPrice &&
                  <div className="flex flex-row mt-4">
                    <Typography className="flex flex-col ml-2">
                      {Dict('service_price') + ": "}
                    </Typography>
                    <Typography className="flex flex-col" color="blue-gray">
                      {persianNumberFormat(currPrice, true) + " ریال"}
                    </Typography>
                  </div>
                }
              </div>

              <div className="mb-4">
                {!service.day && from === "agent" &&
                  <div className="flex flex-row w-3/4">
                    <Input variant="standard"
                           value={currDay}
                           type="number"
                           label={Dict('service_day')}
                           placeholder={Dict('service_day')}
                           onChange={(e) => {
                             setCurrDay(e.target.value)
                           }}
                    />
                  </div>
                }
                {currDay &&
                  <div className="flex flex-row mt-4">
                    <Typography className="flex flex-col ml-2">
                      {Dict('service_day') + ": "}
                    </Typography>
                    <Typography className="flex flex-col" color="blue-gray">
                      {persianNumberFormat(currDay, true) + " روز"}
                    </Typography>
                  </div>
                }
              </div>
            </>
          }
        </div>

        {branchInfo.consensual && from === "agent" && !disable && (!service.price || !service.day) &&
          <div className="flex flex-row mt-2 justify-end">
            <Button variant="gradient" onClick={() => {
              let stop = false
              if (branchInfo.min_price > currPrice || branchInfo.max_price < currPrice) {
                Toaster.failure(null,
                  <Typography variant={"small"}>
                    بازه قیمت رعایت نشده است
                  </Typography>);
                stop = true
              }
              if (branchInfo.min_day > currDay || branchInfo.max_day < currDay) {
                Toaster.failure(null,
                  <Typography variant={"small"}>
                    بازه دوره انجام کار رعایت نشده است
                  </Typography>);
                stop = true
              }
              if (stop) {
                return
              }
              setCurrPrice(currPrice)
              setCurrDay(currDay)
              setService(service => ({
                ...service,
                price: currPrice,
                day: currDay,
              }))
              setLastDataRefresh(Date.now())
              save()
            }} color="gray" className="ml-1">
              <span>ثبت هزینه و دوره انجام کار خدمات</span>
            </Button>
          </div>
        }

        {from === "person" &&
          <Alert className="mt-8 w-full px-0" variant="outlined">
            <Typography variant="h5" className="mb-4">
              کاربر گرامی، لطفا به نکات زیر توجه فرمائید:
            </Typography>
            <Typography variant="body" color="blue-gray">
              <li>
                قیمت های اعلامی از سوی مشاوران فقط شامل هزینه های حق الزحمه ایشان برای آن خدمت می باشد،
                هزینه
                های جانبی و دولتی خدمت، در قیمت ها لحاظ نشده است و باید توسط خودتان پرداخت گردد.
              </li>
            </Typography>
            <Typography variant="body" color="blue-gray">
              <li>
                پرداخت امن مباشر چیست؟ هزینه پرداخت شده از سوی شما، نزد پلتفرم مباشر به امانت خواهد ماند
                و
                پس
                از
                اتمام فرآیند در وجه مشاور مربوطه آزاد خواهد شد.
              </li>
            </Typography>
          </Alert>
        }

      </>
    );
  }
}